import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from '@material-ui/core/Container';
import {
  StyledFlexContainer,
  StyledImageContainer,
  StyledLink,
  StyledHyperLink,
} from './MobileApp.styled';
import { baseUrl } from '../../config/baseUrl';
import { MainLayout } from '../../layouts';

const MobileApp = (props) => {
  const { t } = useTranslation();

  return (
    <MainLayout>
        <Container>
          <StyledFlexContainer>
            <StyledImageContainer>
              <img src={`${baseUrl}img/mobile-app/qr_utraffic_download.png`} alt='QR Code' />
              <small>{t('ScanDownload')}</small>
            </StyledImageContainer>
          </StyledFlexContainer>
          <div>
            <h1>{t('IntroductionTitle')}</h1>
            <p>{t('Introduction1')}</p>
            <p>{t('Introduction2')}</p>
            <p>{t('Introduction3')}</p>
          </div>
          <div>
            <h1>{t('FeaturesTitle')}</h1>
            <p>{t('Feature1')}</p>
            <ul>
              <li>{t('TrafficStatus1')}</li>
              <li>{t('TrafficStatus2')}</li>
              <li>{t('TrafficStatus3')}</li>
              <li>{t('TrafficStatus4')}</li>
              <li>{t('TrafficStatus5')}</li>
            </ul>
            <p>{t('Feature2')}</p>
            <p>{t('Feature3')}</p>
            <p>
              <strong>{t('Reward')}</strong> {t('Feature4')}
            </p>
          </div>
          <div>
            <h1>{t('ManualTitle')}</h1>
            <StyledLink to={`${baseUrl}mobile-app/instruction`}>{t('ViewNow')}</StyledLink>
          </div>
          <div>
            <h1>{t('SupportTitle')}</h1>
            <p>
              {t('Support1')}{' '}
              <StyledHyperLink href='mailto:duonghoaiphong65@gmail.com'>
                duonghoaiphong65@gmail.com
              </StyledHyperLink>
              {', '}
              <StyledHyperLink href='mailto:1870692@hcmut.edu.vn'>
                1870692@hcmut.edu.vn
              </StyledHyperLink>{' '}
              {t('Support2')}
            </p>
            <p>{t('ThankYou')}</p>
          </div>
        </Container>
    </MainLayout>
  );
};


export default MobileApp;
